import { Autocomplete, Button, CircularProgress, Divider, Drawer, FormLabel, Grid, TextField, Typography } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useDrawerStore } from "../../../hooks/useDrawerStore";
import { useSearcherStore } from "../../../hooks/useSearcherStore";
import { useSupplierStore } from "../../../hooks/useSupplierStore";
import { ApiStatus } from "../../../types/api/status";
import { CustomSnackbar } from "../../../components/common/CustomSnackbar/CustomSnackbar";
import { Formik } from "formik";
import { useDocumentOfSalesStore } from "../../../hooks/useDocumentOfSalesStore";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { useReferenceDocumentStore } from "../../../hooks/useReferenceDocumentStore";
import { useSellerStore } from "../../../hooks/useSellerStore";
import { ModalConfirm } from "../../../components/common/ModalConfirm/ModalConfirm";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'document', label: 'Tipo doc.', align:'center' },
    { type: 'text', field: 'folio', label: 'Folio', align:'center' },
    { type: 'text', field: 'description', label: 'Observación', align:'center' },
];

export const DrawerSelectSalesman:FC<any> = (props):JSX.Element|any => {

    const { getFilterProducts, setProducts, setTypeList } = props;

    const { selectedCustomer, setSelectedCustomer, selectedSalesman, setSelectedSalesman, setPricelistName } = useSearcherStore();
    const { openSelectSalesman, setDrawerSelectSalesman} = useDrawerStore();
    const { getSellers } = useSellerStore();

    const [loading, setLoading] = useState(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [sellers, setSellers] = useState<any>([]);
    const [salesmanSelected, setSalesmanSelected] = useState<any>('');

    useEffect(() => {
        if(openSelectSalesman) getSellersApi();
    },[openSelectSalesman]);

    useEffect(() => {
        if (selectedSalesman) {
            getFilterProductsApi(selectedSalesman?.id);
        };
    },[selectedSalesman])

    const getSellersApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getSellers(search);
            if(!response){
                setSellers([]);
                setLoading(false);
                return false;
            }else{
                setSellers(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const getFilterProductsApi = (idsalesman) => {
        setProducts([]);
        setTypeList('general');
        getFilterProducts && getFilterProducts({
            idcustomer: selectedCustomer?.id ?? '', 
            idsalesman: idsalesman ?? '', 
            idcategory_product: '', 
            idsubcategory_product: '',
            page: "",
            perPage: ""
        });
    }
    
    const onChangeCustomer = (rowSelected:any) => {
        setSalesmanSelected(rowSelected);
        setShowModalConfirm(true);
        setPricelistName('');
    }

    const onChangeConfirm = async() => {
        if (salesmanSelected) {
            setSelectedSalesman(salesmanSelected);
            setSelectedCustomer(null);
            setShowModalConfirm(false);
            CustomSnackbar('success', 'Vendedor seleccionado: ' + salesmanSelected.name)
        }
    }
    return (
        <>
        <Drawer anchor="left" open={openSelectSalesman} onClose={() => setDrawerSelectSalesman(false)} ModalProps={{ keepMounted: true }} PaperProps={{ sx: { width: 550 }}}>
            <Grid container spacing={2} padding={4}>
                <Grid item xs={12}>
                    <Typography sx={{ color: '#000000' }}>RUT</Typography>
                    <Autocomplete
                        disablePortal
                        id="combo-box-customer"
                        value={selectedSalesman}
                        options={sellers || []}
                        getOptionLabel={(option) => option.rut || ""}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        fullWidth
                        renderInput={(params) => <TextField {...params} size="small"
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }} />}
                        onChange={(e, newValue) => {
                            onChangeCustomer(newValue);
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography sx={{ color: '#000000' }}>Vendedor</Typography>
                    <TextField
                        id="customer"
                        type="text"
                        name="customer"
                        fullWidth
                        size="small"
                        value={selectedSalesman ? (selectedSalesman?.name + ' ' + (selectedSalesman?.surname ?? '')) : ''}
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                </Grid>
            </Grid>
        </Drawer>
        {
            showModalConfirm && (
                <ModalConfirm
                    title={"Seleccionar vendedor"}
                    open={showModalConfirm}
                    closeModal={()=>{ setShowModalConfirm(false)}}
                    onConfirm={onChangeConfirm}
                    text={"¿Está seguro de realizar el cambio de vendedor?. Si cuenta con productos en su carrito, los precios y descuento de estos pueden sufrir algunos cambios significativos."}
                    // status={loading}
                />
            )
        }
        </>
    )
}